import React, { Component } from 'react';
import { Container, Row, Col, Button, Accordion } from 'react-bootstrap';
import { Helmet } from "react-helmet";
// import AlgoTradeCriteria from './AlgoTradeCriteria';
import PubSub from 'pubsub-js';
// import { TypeAHeadNavigateForChart } from './TypeAHeadNavigateForChart';
import AlgoDisplayStockPrice from './AlgoDisplayStockPrice';
import ChartAlgoDisplay from './ChartAlgoDisplay';
import Indicators from './Indicators';
import Algorithms from './Algorithms';
import StockQuote1 from '../quote/StockQuote1';
import StockCompanyRatings from './StockCompanyRatings';
// import StockLevelTwo from './StockLevelTwo';
import ApiService from '../../service/ApiService';
import { convertDateForIos } from '../../service/Util';
import { calculateAndBestStratergy, setStockAlgoList } from '../../service/Stratergy';
import ChartAlgo from './ChartAlgo';
import AutoDraw from './AutoDraw';
import Paypal from '../dashboard/Paypal';

class AlgoTradeWrap extends Component {
  constructor(props) {
    super(props);
    console.log('Loading algotradewrap');
    this.state = {
      symbol: this.props.symbol,
      interval: 'daily',
      data: [],
      exchange: this.props.exchange,
      reload: true
    };
    console.log('symbol', this.props.symbol, this.state.symbol);
  }

  componentDidMount() {
    this.quoteTrigger = PubSub.subscribe('stockQuoteTypeHead', (topic, data) => {
      let symbol = data.symbol;
      console.log('AlgoTrade stockQuoteTypeHead Received data', data);
      this.setState({ symbol: symbol, interval: 'daily', reload: true }, () => {
        this.setDynamicInterval();
      });
    });

    this.setDynamicInterval();
    window.scrollTo(0, 0);
  }

  custom_sort(a, b) {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  }

  getFormattedDateString(d) {
    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
  }

  setDynamicInterval() {
    let intervalValue = 0;
    console.log('Calling dynamic interval before', this.state.interval, '**');
    clearInterval(this.interval);
    if (this.state.interval === '1min') { intervalValue = 1 };
    if (this.state.interval === '5min') { intervalValue = 5 };
    if (this.state.interval === '15min') { intervalValue = 15 };
    if (this.state.interval === '30min') { intervalValue = 30 };
    if (this.state.interval === '1hour') { intervalValue = 60 };
    if (this.state.interval === '4hour') { intervalValue = 240 };
    if (this.state.interval === 'daily') { intervalValue = 2400 };
    console.log('Calling dynamic interval', this.state.interval, intervalValue);
    this.getData();
    this.interval = setInterval(() => { this.setDynamicInterval() }, 1000 * 10 * intervalValue);

  }

  getData() {

    if (this.state.interval === 'daily') {
      ApiService.getHistoricalQuotesFull(this.state.symbol)
        .then(result => {
          console.log('historicalquotesfull', result.historical);

          //Get current Quote
          ApiService.getQuotes(this.state.symbol)
            .then(currentQuote => {
              console.log('Current Quote', currentQuote);

              //Get Earning calender
              ApiService.getEarningSurprises(this.state.symbol)
                .then(earningSurprises => {
                  console.log('Earning Surprises', earningSurprises);


                  //Get Divdend calender
                  ApiService.getStockDividend(this.state.symbol)
                    .then(stockDividend => {
                      console.log('Stock Dividend', stockDividend);
                      stockDividend = stockDividend.historical;
                      this.processDataForDaily(result.historical, currentQuote, earningSurprises, stockDividend);
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });

    } else {
      ApiService.getStockHistoricalPrice(this.state.symbol, this.state.interval)
        .then(result => {
          console.log('intraday', result);
          this.processData(result);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  processDataForDaily(result, currentQuote, earningSurprises, stockDividend) {
    console.log('Loading daily');
    let calculateAndBestStratergyTmp = [];
    if (result !== null && result !== undefined && result.length > 0) {
      let loadCurrentQuote = true;
      const resultProductData = result;
      let filteredData = [];
      for (var i = 0; i < resultProductData.length; i++) {
        let estDate = new Date(resultProductData[i].date);
        //Convert to EST timezone
        resultProductData[i].date = new Date(estDate.getTime() + Math.abs(estDate.getTimezoneOffset() * 60000));

        //Add Earning surprises
        if (earningSurprises !== undefined && earningSurprises.length !== undefined) {
          for (var j = 0; j < earningSurprises.length; j++) {
            // console.log('earning surprises dates', earningSurprises[j].date, resultProductData[i].date)
            let formattedDate = this.getFormattedDateString(resultProductData[i].date);
            if (earningSurprises[j].date === formattedDate) {
              // console.log('earning surprises matches', earningSurprises[j].date, formattedDate);
              resultProductData[i].actualEarningResult = earningSurprises[j].actualEarningResult;
              resultProductData[i].estimatedEarning = earningSurprises[j].estimatedEarning;
              break;
            }
          }
        }

        //Add Dividend
        if (stockDividend !== undefined && stockDividend.length !== undefined) {
          for (j = 0; j < stockDividend.length; j++) {
            let formattedDate = this.getFormattedDateString(resultProductData[i].date);
            if (stockDividend[j].date === formattedDate) {
              //console.log('Dividend matches', stockDividend[j].date);
              resultProductData[i].dividend = stockDividend[j].dividend;
              break;
            }
          }
        }

        // console.log('resultProductData[i].date ', resultProductData[i].date );
        filteredData.push(resultProductData[i]);
      }
      console.log('historical price', result, filteredData);
      filteredData.sort(this.custom_sort);

      let today = new Date()
      let loadedDate = filteredData[filteredData.length - 1].date;
      let loadedLastClose = filteredData[filteredData.length - 1].close;
      // console.log('today', today.getFullYear(), today.getMonth(), today.getDate());
      // console.log('today loadDate', loadedDate.getFullYear(), loadedDate.getMonth(), loadedDate.getDate());

      //Check if todays data is already loaded
      if (today.getFullYear() === loadedDate.getFullYear() && today.getMonth() === loadedDate.getMonth() && today.getDate() === loadedDate.getDate()) {
        console.log('Found todays data - already loaded');
        loadCurrentQuote = false;
      }
      //Check if the last close is same as todays close
      if (currentQuote !== undefined && currentQuote.length !== undefined && currentQuote.length > 0 &&
        loadedLastClose === currentQuote[0].price) {
        console.log('Found todays data - already loaded may be the market is closed');
        loadCurrentQuote = false;
      }

      //Add current quote
      if (currentQuote !== undefined && currentQuote.length !== undefined && currentQuote.length > 0 && loadCurrentQuote) {
        console.log('Found todays data - not so loading');
        let tmpObj = {
          open: currentQuote[0].open,
          low: currentQuote[0].dayLow,
          high: currentQuote[0].dayHigh,
          close: currentQuote[0].price,
          volume: currentQuote[0].volume,
          date: new Date()
        }
        filteredData.push(tmpObj);
      }
      console.log('historical full data', filteredData, resultProductData[0]);
      calculateAndBestStratergyTmp = calculateAndBestStratergy(filteredData);
      console.log('calculateAndBestStratergy daily', calculateAndBestStratergyTmp, calculateAndBestStratergyTmp.data);
    }
    this.publishChartData(result, calculateAndBestStratergyTmp);
  }

  processData(result) {
    console.log('Loading intraday');
    let calculateAndBestStratergyTmp = [];
    if (result !== null && result !== undefined && result.length > 0) {
      const resultProductData = result;
      let filteredData = [];
      for (var i = 0; i < resultProductData.length; i++) {
        resultProductData[i].date = convertDateForIos(resultProductData[i].date);
        filteredData.push(resultProductData[i]);
      }
      console.log('historical price', result, filteredData);
      filteredData.sort(this.custom_sort);
      console.log('historical full data', filteredData, resultProductData[0]);
      calculateAndBestStratergyTmp = calculateAndBestStratergy(filteredData);
      console.log('calculateAndBestStratergy intraday', calculateAndBestStratergyTmp, calculateAndBestStratergyTmp.data);
    }
    this.publishChartData(result, calculateAndBestStratergyTmp);
  }

  publishChartData(result, calculateAndBestStratergyTmp) {
    if (result !== null && result !== undefined && result.length > 0) {
      let stockAlgoList = this.filterAlgoData(calculateAndBestStratergyTmp);

      let tmpProfitList = calculateAndBestStratergyTmp.profitList.slice();
      tmpProfitList.sort(this.custom_sort_profit);
      let tmpAlgoSelected = {
        target: {
          value: tmpProfitList[0].stratergy.toLowerCase(),
          name: tmpProfitList[0].stratergyName,
          checked: true,
        }
      }

      this.setState({
        data: calculateAndBestStratergyTmp.data,
      }, () => {
        let tmpObj = {
          data: calculateAndBestStratergyTmp.data,
          selectedAlgo: tmpAlgoSelected
        }
        console.log('chartRefresh', calculateAndBestStratergyTmp, tmpAlgoSelected, stockAlgoList); 
        PubSub.publish('chartRefresh', tmpObj);
        PubSub.publish('chartAlgoDisplay', stockAlgoList);
        setStockAlgoList(stockAlgoList);  //Set this for Backtest result page
        PubSub.publish('chartAlgoSelectedTrigger', tmpAlgoSelected);
      });
    } else {
      PubSub.publish('chartRefresh', []);
      PubSub.publish('chartAlgoDisplay', []);
      setStockAlgoList([]);//Set this for Backtest result page
    }
  }

  custom_sort_profit(a, b) {
    return b.totalProfit - a.totalProfit;
  }

  filterAlgoData(origData) {
    let data = origData.data;
    let tmpList = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].emaLongShort !== undefined) {
        tmpList.push(data[i]);
      }
      if (data[i].smaLongShort !== undefined) {
        tmpList.push(data[i]);
      }
      if (data[i].macdLongShort !== undefined) {
        tmpList.push(data[i]);
      }
      if (data[i].rsiLongShort !== undefined) {
        tmpList.push(data[i]);
      }
    }

    //Add Quote timeframe for backtest result page
    let quote = {symbol: this.state.symbol, interval: this.state.interval};
    return { data: tmpList, profitList: origData.profitList, quote: quote };
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.quoteTrigger);
    clearInterval(this.interval);
  }

  componentDidUpdate(nextProps) {
    console.log('AlgoTradeWrap before if', nextProps.symbol, this.state.symbol);
    if (nextProps.symbol !== this.state.symbol) {
      this.setState({ symbol: nextProps.symbol, interval: 'daily', reload: true }, () => {
        console.log('AlgoTradeWrap', this.state.symbol);
        this.setDynamicInterval();
      });
    }
  }

  onIntradaySelection = (interval) => {
    let intervalValue = interval.target.value;
    this.setState({ interval: intervalValue, reload: true }, () => {
      console.log('interval selection', intervalValue, this.state.interval);
      this.setDynamicInterval();
    });
  }

  render() {
    if (this.state.reload) {
      console.log('AlgoTradeWrap Reloading...');
      this.setState({ reload: false });
      return (<div>Loading...</div>);
    }

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.symbol} - Chart Daily & Intraday</title>
          <link rel="canonical" href="https://www.vizfm.com/chart" />
          <meta name="description" content="Algorithmic Trade Signals, Daily and Intraday Charts for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          {/* <Row style={{ backgroundColor: 'grey' }}>
            <Col xs={12} sm={10} md={6} lg={4} style={{ height: '31px' }}>
              <TypeAHeadNavigateForChart />
            </Col>
            <Col xs={12} sm={10} md={5} lg={4}>Intraday Chart / Algorithm Signals</Col>
            <Col xs={3} sm={4} md={2} lg={1}><Indicators /></Col>
            <Col xs={3} sm={4} md={2} lg={1}><Algorithms /></Col> 
            <Col md={1}></Col>
          </Row> */}
          <Row>
            {/* <Col md={1}></Col> */}
            <Col xs={12} sm={12} md={5} lg={3} xl={3}><AlgoDisplayStockPrice symbolName={this.state.symbol} ticker={this.state.symbol} interval={this.state.interval} /></Col>
            <Col xs={12} sm={12} md={7} lg={4} xl={4}>
              <Button variant={this.state.interval === '1min' ? 'primary' : 'link'} size="sm" value="1min" onClick={this.onIntradaySelection}>1 min</Button>
              <Button variant={this.state.interval === '5min' ? 'primary' : 'link'} size="sm" value="5min" onClick={this.onIntradaySelection}>5 min</Button>
              <Button variant={this.state.interval === '15min' ? 'primary' : 'link'} size="sm" value="15min" onClick={this.onIntradaySelection}>15 min</Button>
              <Button variant={this.state.interval === '30min' ? 'primary' : 'link'} size="sm" value="30min" onClick={this.onIntradaySelection}>30 min</Button>
              <Button variant={this.state.interval === '1hour' ? 'primary' : 'link'} size="sm" value="1hour" onClick={this.onIntradaySelection}>1 Hr</Button>
              <Button variant={this.state.interval === '4hour' ? 'primary' : 'link'} size="sm" value="4hour" onClick={this.onIntradaySelection}>4 Hrs</Button>
              <Button variant={this.state.interval === 'daily' ? 'primary' : 'link'} size="sm" value="daily" onClick={this.onIntradaySelection}>Daily</Button>
            </Col>
            <Col xs={4} sm={4} md={2} lg={1} xl={1}><Indicators /></Col>
            <Col xs={4} sm={4} md={2} lg={2} xl={2}><Algorithms /></Col>
            <Col xs={4} sm={4} md={2} lg={1} xl={1}><AutoDraw /></Col>
          </Row>
          <Row>
            {/* <Col md={9} style={{ height: '500px' }}> */}
            <Col xs={12} sm={12} md={12} lg={8}>
              {/* svg, hybrid */}
              <ChartAlgo type={'svg'} data={this.state.data} />  
            </Col>
            <Col xs={12} sm={12} md={12} lg={4}>
              <Paypal />
              <ChartAlgoDisplay limit={8} text={'BEST Algo. Signal*'} order={0} />
              {this.state.exchange ? <p style={{ fontSize: "15px" }}>Company Ratings</p> : <></>}
              {this.state.exchange ? <StockCompanyRatings symbol={this.state.symbol} /> : <></>}
              {/* {this.state.exchange ? <StockLevelTwo symbol={this.state.symbol} /> : <></>} */}
            </Col>
          </Row>
          <Row>
            {/* <AlgoTradeCriteria /> */}
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Backtest / Algorithimic Signals</Accordion.Header>
                <Accordion.Body>
                  <Container fluid className="p-2">
                    <Row>
                      <Col><ChartAlgoDisplay limit={10} text={'Algo. Signal*'} order={1} /></Col>
                      <Col><ChartAlgoDisplay limit={10} text={'Algo. Signal*'} order={2} /></Col>
                      <Col><ChartAlgoDisplay limit={10} text={'Algo. Signal*'} order={3} /></Col>
                    </Row>
                  </Container>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Row>
          <Row>
            {this.state.exchange ? <StockQuote1 symbol={this.state.symbol} /> : <></>}
          </Row>
          <Row>
            <Col style={{ textAlign: 'left', fontSize: '1' }}>
              <small>&nbsp;* - Trade signals are based on Algorithms and please do your analysis before any trades. Always remember to put your stop to minimize your loss incase it goes in the opposite direction.</small>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default AlgoTradeWrap;
